import { createContext, useContext } from "react";

export const CallCtx = createContext(null);

export function useCall() {
  const ctx = useContext(CallCtx);
  if (!ctx) throw new Error("useCall must be used within CallProvider");
  return ctx;
}
